import SpotTravelInfoSummary from './SpotTravelInfoSummary';

export default SpotTravelInfoSummary;
